function useSideBarWidth() {
  const sideBarWidth = localStorage.getItem('xapps@chat:sideBarWidth');
  const updateWidth = (newWidth: string) => localStorage.setItem('xapps@chat:sideBarWidth', newWidth);

  return { sideBarWidth, updateWidth };
}

export { useSideBarWidth };
